/**
 * Unified auth: authenticated if either Microsoft SSO (MSAL) or email JWT is present.
 * Used by ProtectedRoute, Layout, Login, and Signup. Reacts to email token set/clear via event.
 */

import { useEffect, useState } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { getStoredEmailToken, subscribeEmailAuthChange } from '@/auth/emailAuth';

/** True if user has valid session: MSAL account or stored email JWT. */
export function useAuth(): { isAuthenticated: boolean; authMethod: 'sso' | 'email' | null } {
  const msalAuthenticated = useIsAuthenticated();
  const [emailToken, setEmailToken] = useState<string | null>(() => getStoredEmailToken());

  useEffect(() => {
    const unsubscribe = subscribeEmailAuthChange(() => setEmailToken(getStoredEmailToken()));
    return unsubscribe;
  }, []);

  if (msalAuthenticated) return { isAuthenticated: true, authMethod: 'sso' };
  if (emailToken) return { isAuthenticated: true, authMethod: 'email' };
  return { isAuthenticated: false, authMethod: null };
}
